/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Commission_NoteInputs */

const es_landing_price_commission_note = /** @type {(inputs: Landing_Price_Commission_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tú fijas el precio. La comisión sale de ahí.`)
};

const gl_landing_price_commission_note = /** @type {(inputs: Landing_Price_Commission_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti fixas o prezo. A comisión sae de aí.`)
};

const en_landing_price_commission_note = /** @type {(inputs: Landing_Price_Commission_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You set the price. Commission comes out of that.`)
};

/**
* | output |
* | --- |
* | "You set the price. Commission comes out of that." |
*
* @param {Landing_Price_Commission_NoteInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_commission_note = /** @type {((inputs?: Landing_Price_Commission_NoteInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Commission_NoteInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_commission_note(inputs)
	if (locale === "en") return en_landing_price_commission_note(inputs)
	return es_landing_price_commission_note(inputs)
});